<script>
  import {getStyleValue, imageUrl} from "../../Common/tools";
  import {External} from "../../external";

  export let data, globalStyle, placeholderSize = '700x500', isChild = false;
  const placeholder = External.resources + '/images/marketing/placeholders/' + placeholderSize + '.png';

  $: if (!data.style.width) data.style.widht = '100%';
</script>
{#if !isChild}
    <th class="column {data.isFullscreen ? '' : 'column-st'}" width="{getStyleValue(globalStyle.width, 600)}" >
        <img src={imageUrl(data, placeholder)} alt=""
             style="border: 0; width: {data.style.width}; max-width: {getStyleValue(globalStyle.width, '600')}px; margin-bottom: -7px;"
             width="{getStyleValue(globalStyle.width, '600')}"/>

    </th>
{:else}
    <th style="text-align: left;">
        <img src={imageUrl(data, placeholder)} alt=""
             style="border: 0; width: {data.style.width}; max-width: {data.style.width || '310px'}; "
             width="{getStyleValue(data.style.width, 310)}"/>

    </th>
{/if}